export const isEmpty = v => v === undefined || v === null || v === "";
